import { jsxs as m, jsx as p } from "react/jsx-runtime";
import { forwardRef as h, useContext as x, useRef as b, useImperativeHandle as g, useEffect as y } from "react";
import E from "clsx";
import { ExpandableContext as v } from "./expandable-context.js";
import { IS_ANDROID as A } from "../../utils.js";
import s from "../expandable.module.less.js";
const D = h(function({ children: l, className: d, ...r }, a) {
  const { open: t, contentId: u, titleId: c } = x(v), n = b(null);
  return g(a, () => n.current), y(() => {
    if (!n.current)
      return;
    const e = n.current, i = e.firstElementChild, f = `${e.getAttribute("aria-hidden") || !t}` == "true", o = () => {
      e.toggleAttribute("open", t), e.style.overflow = t ? "" : "hidden", e.style.height = "";
    };
    if (e.setAttribute("aria-hidden", `${!t}`), i && i.setAttribute("hidden", ""), f === t)
      return e.setAttribute("open", ""), e.style.overflow = "hidden", e.style.height = t ? "0px" : `${e.scrollHeight}px`, e.clientHeight, e.style.height = t ? `${e.scrollHeight}px` : "0px", e.addEventListener("transitionend", o), () => e.removeEventListener("transitionend", o);
  }, [t]), /* @__PURE__ */ m(
    "details",
    {
      ...r,
      "aria-labelledby": A ? void 0 : c,
      className: E(
        s.content,
        s[t ? "open" : "closed"],
        d
      ),
      id: r.id || u,
      open: t,
      role: "group",
      ref: n,
      children: [
        /* @__PURE__ */ p("summary", {}),
        l
      ]
    }
  );
});
export {
  D as ExpandableContent
};
//# sourceMappingURL=expandable-content.js.map
